import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../../helpers/useFetch';
import ErrorMessage from '../../ErrorMessage';
import FacebookAdsCard from './FacebookAdsCard';

const FacebookAdsCards = ({ stats, period, facebookAds }) => {
  const fetch = useFetch();
  const { domain } = useSelector((state) => state.domain);
  const [adAccountCurrency, setAdAccountCurrency] = useState();
  const [loadError, setLoadError] = useState();
  const [adSetStatuses, setAdSetStatuses] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/facebook/account`)
      .then(({ facebookAccount }) => {
        setAdAccountCurrency(facebookAccount.adAccountCurrency);
      })
      .catch(setLoadError);
  }, [fetch, domain.accountId, domain.id]);

  const fetchAdSetStatuses = useCallback(
    async (facebookAdIds) => {
      fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/facebookAds/progressStatus`, {
        method: 'POST',
        body: JSON.stringify({ facebookAdIds }),
      })
        .then((response) => {
          setAdSetStatuses(response.statuses);
        })
        .catch(setLoadError);
    },
    [domain.accountId, domain.id, fetch]
  );

  useEffect(() => {
    const facebookAdIds = facebookAds.map((ad) => ad.id);
    fetchAdSetStatuses(facebookAdIds);
  }, [fetchAdSetStatuses, facebookAds]);

  if (adAccountCurrency === undefined) {
    return;
  }

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  return facebookAds.map((campaign) => (
    <FacebookAdsCard
      key={campaign.id}
      facebookAd={campaign}
      stats={stats}
      period={period}
      adAccountCurrency={adAccountCurrency}
      currency={domain.currency}
      progress={adSetStatuses?.[campaign.id]}
    />
  ));
};

export default FacebookAdsCards;
